/**--external-- */
import React from "react";

/**--internal-- */
import { FormTextInput } from "UIComponents/InputTextField";
import Textview from "UIComponents/Textview";

/**--relative-- */
import Field from "../Field";

class FieldInput extends Field {
  constructor(props) {
    super(props);
  }

  renderPreviewContent = () => {
    const { testId, placeholder, isRequired } = this.props;
    return (
      <FormTextInput
        mode="edit"
        value={""}
        isRequired={isRequired}
        size="large"
        testId={testId}
        placeholder={placeholder}
        showViewEmpty={false}
      />
    );
  };

  renderView = () => {
    const { value, name, customRef, emptyText, customTextStyle } = this.props;
    return (
      <Textview
        value={value}
        name={name}
        mode="view"
        customRef={customRef}
        emptyText={emptyText}
        customTextStyle={customTextStyle}
      />
    );
  };

  renderEdit = () => {
    const {
      onFocusInputField,
      onBlurInputField,
      updateInputField,
      customRef,
      placeholder,
      isRequired,
      value,
      readOnly,
      name,
    } = this.props;
    return (
      <FormTextInput
        mode="edit"
        size="large"
        name={name}
        value={value}
        readOnly={readOnly}
        customRef={customRef}
        isRequired={isRequired}
        placeholder={placeholder}
        updateInputField={updateInputField}
        onBlurInputField={onBlurInputField}
        onFocusInputField={onFocusInputField}
      />
    );
  };
}

export default FieldInput;

FieldInput.displayName = "FieldInput";
